module.exports = __webpack_public_path__ + "static/media/Admin Building Close Cam 03 .aa846b93.webp";